<template>
  <div class="ClientesListado m-t-16">
    <md-table-card>
      <md-toolbar>
        <h1 class="md-title">Clientes registrados</h1>
      </md-toolbar>
      <md-table>
        <md-table-header>
          <md-table-row>
            <md-table-head>Cuenta</md-table-head>
            <md-table-head>Razón social</md-table-head>
            <md-table-head>Acciones</md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="(cliente,index) in clientes" :key="index">
            <md-table-cell>{{cliente.cuenta}}</md-table-cell>
            <md-table-cell>{{cliente.nombre.toUpperCase()}}</md-table-cell>
            <md-table-cell>
              <md-button class="md-icon-button" @click.native="irAEditarCliente(cliente.cliente)" v-if="admin_cobranza">
                <md-icon>edit</md-icon>
                <md-tooltip md-direction="top">Editar</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </md-table>
    </md-table-card>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import $ from "jquery";
import dt from "datatables.net";
export default {
  name: "ClientesListado",
  methods: {
    obtenerClientes() {
      this.$http
        .post("clientes", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "clientes" in response.body) {
              this.clientes = response.body.clientes;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    irAEditarCliente(id) {
      this.$router.push({ name: "ClientesEditar", params: { cliente: id } });
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    var tipo = this.$session.get("tipo");
    this.admin_cobranza =
      tipo === "administrador" || tipo === "cobranza" ? true : false;
  },
  beforeMount() {
    this.obtenerClientes();
  },
  updated() {
    $(".md-table table").DataTable();
  },
  data() {
    return {
      clientes: [],
      admin_cobranza: false
    };
  }
};
</script>


// WEBPACK FOOTER //
// ClientesListado.vue?12ce9abc